import React, { useState, useEffect } from "react";
import Header from "../components/Welcome/Header";
import HeroSection from "../components/Welcome/HeroSection";
import HowItWorks from "../components/Welcome/HowItWorks";
import BetaSignup from "../components/Welcome/BetaSignup";
import Footer from "../components/Footer";
import MissionVision from "../components/Welcome/MissionVision";
import "../components/Welcome/Welcome.css";

export default function Welcome() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="welcome-container">
      <Header isMobile={isMobile} />
      <HeroSection isMobile={isMobile} />
      <MissionVision isMobile ={isMobile} />
      <HowItWorks isMobile={isMobile} />
      <BetaSignup isMobile={isMobile} />
      <Footer />
    </div>
  );
}